<div class="container-fluid full-height">
    <div class="two-col-row h-100">
        <div class="leftside-image col-hide-sm"></div>

        <div class="customer-form">
            <div class="text-center">
                <img src="../../../../assets/images/logo.png" alt="Synergetics Logo" style="width: 280px;">
            </div>
            <h4 class="customer-title text-center">Customer Enquiry</h4>

            <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">

                <label>Organization Name *</label>
                <input type="text" formControlName="customerName" matInput/>

                <label>Contact Person *</label>
                <input type="text" formControlName="contactPerson" matInput/>

                <label>Email *</label>
                <input type="email" formControlName="email" matInput/>

                <label>Mobile Number </label>
                <input type="text" formControlName="mobileNumber" matInput/>

                <label>Subject *</label>
                <textarea formControlName="subject" rows="2" matInput></textarea>

                <label>Enquiry Details *</label>
                <textarea formControlName="enquiryDetails" rows="2" matInput></textarea>

                <div class="form-actions">
                    <button type="submit" class="my-btn" [disabled]="enquiryForm.invalid">Send</button>
                    <button type="button" class="my-btn" (click)="onReset()">Reset</button>
                </div>
                <div>
                    <div>
                        <a href="/login" class="pull-left" style="padding-bottom: 5px;">Go to Login</a>
                    </div>
                </div>
            </form>
        </div>
    </div>

    
    <!-- Success Popup -->
    <div *ngIf="showPopup" class="popup-overlay">
        <div class="popup-content">
            <div class="popup-header">
                <h3>Success!</h3>
            </div>
            <div class="popup-body">
                <p>Customer Enquiry Sent Successfully. ! You will be redirected to login.</p>
            </div>
            <div class="popup-footer">
                <button class="my-btn" (click)="stopRedirect()">
                    Stop ({{ countdown }})
                </button>
            </div>
        </div>
    </div>

    <!-- Preview Popup -->
<!-- Preview Popup -->
<div *ngIf="showPreview" class="popup-overlay">
  <div class="popup-content">
    <div class="popup-header">
      <h3>Confirm Your Enquiry</h3>
    </div>
    
    <div class="popup-body">
      <div class="flex-between" *ngFor="let field of [
        { label: 'Customer Name', value: formDataToSubmit.customerName },
        { label: 'Contact Person', value: formDataToSubmit.contactPerson },
        { label: 'Email', value: formDataToSubmit.email },
        { label: 'Mobile Number', value: formDataToSubmit.mobileNumber },
        { label: 'Subject', value: formDataToSubmit.subject },
        { label: 'Enquiry Details', value: formDataToSubmit.enquiryDetails }
      ]">
        <div class="text-end fw-bold">{{ field.label }}:</div>
        <div>{{ field.value }}</div>
      </div>
    </div>
    <div class="popup-footer text-center">
      <button class="my-btn" (click)="confirmSubmit()">Confirm</button>
      <button class="my-btn" (click)="cancelPreview()">Cancel</button>
    </div>
  </div>
</div>

</div>

